import { render, staticRenderFns } from "./InputFeed.vue?vue&type=template&id=0662aebc&scoped=true&"
import script from "./InputFeed.vue?vue&type=script&lang=js&"
export * from "./InputFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662aebc",
  null
  
)

export default component.exports